import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CalendarDay } from '../../models/calendar.models';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'loyaltic-day-tile',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './day-tile.component.html',
  styleUrls: ['./day-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DayTileComponent {
  @Input() day!: CalendarDay;
  @Input() selected = false;
  @Input() isToday = false;
  @Input() isLoggedIn = false;
  @Output() play = new EventEmitter<CalendarDay>();
  @Output() hover = new EventEmitter<boolean>();
  gamesAvailable = 0;

  @HostBinding('class.tile--h2')
  get spanRows(): boolean {
    const span = this.day?.span;
    return span === '1x2' || span === '2x2';
  }

  @HostBinding('class.tile--today')
  get hostToday(): boolean {
    return this.isToday;
  }

  @HostBinding('class.tile--w2')
  get spanCols(): boolean {
    const span = this.day?.span;
    return span === '2x1' || span === '2x2';
  }

  constructor(private authService: AuthService, private coreService: CoreService) {

  }

  ngOnInit() {
    this.isLoggedIn = this.authService.IsLoggedIn();
  }

  get spanClasses(): string[] {
    const classes = [];
    return classes;
  }

  onClick(): void {
    if (!this.day || this.day.state !== 'active') {
      return;
    }

    this.play.emit(this.day);
  }

  checkSlotStatus(targetDate: string): boolean {
    if (this.isLoggedIn) {
    let participateApiResult = JSON.parse(localStorage.getItem('participateApiResult'));
    // Normalize the target date (ignore time differences)
    const formattedTarget = new Date(targetDate).toDateString();

    // Find the slot matching the given date
    const slot = participateApiResult.slotsInfo.find(s => new Date(s.date).toDateString() === formattedTarget);

    // Return true if the slot exists and status is "COMPLETED"
    return slot ? slot.slotStatus === 'COMPLETED' : false;
    } else {
      return true;
    }
  }

  checkPartialSlotStatus(targetDate: string): boolean {
    if (this.isLoggedIn) {
      let participateApiResult = JSON.parse(localStorage.getItem('participateApiResult'));
      // Normalize the target date (ignore time differences)
      const formattedTarget = new Date(targetDate).toDateString();

      // Find the slot matching the given date
      const slot = participateApiResult.slotsInfo.find(s => new Date(s.date).toDateString() === formattedTarget);

      // Return true if the slot exists and status is "COMPLETED"
      return slot ? slot.slotStatus === 'PARTIAL' : false;
    } else {
      return true;
    }
  }

  returnSlotCount(targetDate: string): number {
    if (this.isLoggedIn) {
      let participateApiResult = JSON.parse(localStorage.getItem('participateApiResult'));
      // Normalize the target date (ignore time differences)
      const formattedTarget = new Date(targetDate).toDateString();

      // Find the slot matching the given date
      const slot = participateApiResult.slotsInfo.find(s => new Date(s.date).toDateString() === formattedTarget);
      // Return true if the slot exists and status is "COMPLETED"
      return slot.games.filter((game:any) => !game.isPlayed).length;
    }
  }


  getClass(state:string, selected:boolean) {
    if (this.isLoggedIn) {
      let selectedClass ='';
      if (selected) {
        selectedClass = 'tile--selected' 
      }
      return `tile--${state} ${selectedClass}`
    } else {
      return '';
    }
  }

  onMouseEnter(): void {
    if (this.day?.state === 'active') {
      this.hover.emit(true);
    }
  }

  onMouseLeave(): void {
    this.hover.emit(false);
  }
}
